import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Project } from "../../../_core/state/project";
import { CartService } from "../../../_core/state/cart/cart.service";
import { Router } from "@angular/router";

@Component({
  selector: 'app-project-item-thumbnail-card-hover',
  templateUrl: './project-item-thumbnail-card-hover.component.html',
  styleUrl: './project-item-thumbnail-card-hover.component.scss'
})
export class ProjectItemThumbnailCardHoverComponent implements OnInit {
	@Input()  project: Project;
	@Output() closeOverlay = new EventEmitter<void>();

	public readonly MAX_DISPLAYED_ITEMS = 6;

	constructor(public readonly projectCartService: CartService,
				private readonly router: Router) {
	}

	ngOnInit() {
	}

	public getGridTemplateClass(thumbnailCount: number) {
		if (!thumbnailCount) {
			return;
		}

		if (thumbnailCount === 2) {
			return 'two-item';
		} else if (thumbnailCount === 3) {
			return 'three-item';
		} else if (thumbnailCount === 4) {
			return 'four-item';
		} else if (thumbnailCount === 5) {
			return 'five-item';
		} else if (thumbnailCount > 5) {
			return 'six-item';
		}
	}

	openProject() {
		this.closeOverlay.emit();
		this.router.navigate(['/project', this.project.id]);
	}

	filterNoNameItems(item: any) {
		return item?.name !== '';
	}
}
